export default __webpack_public_path__ + "./images/bz.46b98faa.png";